export const formatCurrency = (amount) =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(amount ?? 0);

export const formatDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
};

/** Placeholder hint based on vehicle type */
export const platePlaceholder = (vehicleType) =>
  vehicleType === 'moto' ? 'A123ABC' : 'AB123CD';

/**
 * Label for exit charge UI. amount_charged on exit is often a total/reconciliation;
 * paid_at_entry means parking was already settled at entry — nothing new to collect.
 */
export const getExitChargeLabel = (preview) => {
  if (!preview) return '';
  if (preview.is_member) return 'Sin cargo (SOCIO)';
  if (preview.paid_at_entry) return 'Ya pagado en entrada';
  return formatCurrency(preview.amount_charged);
};

export const hasExitAmountDue = (preview) => {
  if (!preview) return false;
  if (preview.is_member || preview.paid_at_entry) return false;
  return (preview.amount_charged ?? 0) > 0;
};
